import createElement from '@javascripts/utils/create_element';

export default class ContentTitle {
  constructor({ tech, data } = {}) {
    this._tech = tech;
    this._data = data;
  }

  init() {
    this.addClassToContainer();
    this.appendComponent();
  }

  addClassToContainer() {
    if (this.data().filmTitle() === '') {
      this.tech().el().addClass('content-title--avod');
    }
  }

  appendComponent() {
    this.tech().el().appendChild(this.titleComponent());
  }

  titleComponent() {
    return createElement(`
      <div class="content-title">
        <span class="content-title-big">${this.getContentTitle()}</span>
        <span class="content-title-season">${this.createSeasonEpisodeTitle()}</span>
      </div>
    `);
  }

  createSeasonEpisodeTitle() {
    return `${this.getSeasonName()}${this.showDivider()}${this.getVideoTitle()}`;
  }

  showDivider() {
    return this.getSeasonName() && this.getVideoTitle() ? ' • ' : '';
  }

  getSeasonName() {
    return this.seasonName() ? this.seasonName() : '';
  }

  getVideoTitle() {
    return this.seasonName() ? this.data().videoTitle() : '';
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  getContentTitle() {
    return this.data().filmTitle() ? this.data().filmTitle() : this.data().videoTitle();
  }

  seasonName() {
    return this.data().seasonName();
  }

  episodeNumber() {
    return this.data().episodeNumber();
  }

}
